import React from "react";
import { Box } from "@mui/material";
import OrientationSlider from "./OrientationSlider";
import TiltAngleCard from "./TitlAngleCard";
import PeakPowerSlider from "./PeakPower";
import ModeSelection from "./shadow-setup/ModeSelection";
import SystemTypeChooseCard from "./SystemTypeChooseCard";
import MultiSelectChips from "./MultiSelectChips";
import StylishCounterCard from "./PeakPowerCounter";
import BudgetSlider from "./BudgetSlider";

const EasySetupScreen = ({
  orientation,
  onOrientationChange,
  tiltAngle,
  onTiltAngleChange,
  peakPower,
  onPeakPowerChange,
  productionData,
  onShadowChange,
  systemType,
  onSystemTypeChange,
  onConsumptionChange,
  budget,
  onBudgetChange,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "#1c1c28",
        mb: 10,
        p: { xs: 2, sm: 4 },
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <OrientationSlider
        orientation={orientation}
        onOrientationChange={onOrientationChange}
      />
      <TiltAngleCard
        tiltAngle={tiltAngle}
        onTiltAngleChange={onTiltAngleChange}
      />
      <StylishCounterCard
        peakPower={peakPower}
        onPeakPowerChange={onPeakPowerChange}
      />

      <ModeSelection
        productionData={productionData}
        onHorizonChange={onShadowChange}
      />
      <SystemTypeChooseCard
        systemType={systemType}
        onSystemTypeChange={onSystemTypeChange}
      />
      <MultiSelectChips onConsumptionChange={onConsumptionChange} />
      <BudgetSlider orientation={budget} onOrientationChange={onBudgetChange} />
    </Box>
  );
};

export default EasySetupScreen;
